  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 
    import UsuarioService from   "@/service/v1/seguranca/UsuarioService"  

    @Options({
        name: "AlunosPdf",
        components: {  CardRh  },   
    }) 
    export default class AlunosPdf extends Vue { 
        
        @authStore.Getter
		public token!: any  
  
        public service = new UsuarioService(); 

        @Prop( ) readonly turma!: any   
        @Prop( ) readonly pelotao!: any   

        public identificador = 1 ;   
         
        public url: any = null;
        public modal: any = "modal_pdf_lista_alunos";
  
        public gerarBoletim(){ 
            this.url =   null; 
            if(!this.turma || !this.pelotao){
                return;
            }
            setTimeout(() => {
                this.url = this.service.getApiUrl() + '/Dados/Pdf?turmaId=' + this.turma + '&pelotao=' + this.pelotao +   '&token=' + this.token ; 
                this.identificador++;
            }, 2 );  
        }
    } 
